import "./assets/js/app"; // メインJS
import "./assets/sass/app.scss"; // メインCSS

const boxes = document.querySelectorAll('.mo');
const boxesArray = Array.prototype.slice.call(boxes, 0);

function doWhenIntersect(entries) {
    const entriesArray = Array.prototype.slice.call(entries, 0);
    entriesArray.forEach((entry) => {
        if (entry.isIntersecting) {
            entry.target.classList.add("show");
        }
    });
}

const options = {
    root: null,
    rootMargin: '0px 0px -10%',
    threshold: 0
};

const observer = new IntersectionObserver(doWhenIntersect, options);
boxesArray.forEach((box) => {
    observer.observe(box);
});